import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { loadAccountType, loadPlanSuccess, updateSelectedPlanAnnual } from "../../../data/user/actions";
import { isLegacyAccountPlan, selectPlanDetails, selectUserId } from '../../../data/user/selectors';
import numberFormat from 'utils/number/format';
import css from '../style.scss';
import config from 'config';
import ErrorDisplay from '../components/ErrorDisplay';
import { ReactSVG } from 'react-svg';

import EssentialsIcon from "assets/images/account-page-plan-essentials.svg";
import ProIcon from "assets/images/account-page-plan-pro.svg";
import EliteIcon from "assets/images/account-page-plan-elite.svg";
import LegacyIcon from "assets/images/account-page-plan-legacy.svg";
import LeaveMessagePopup from "../modals/LeaveMessage";
import LoadablePanel from 'components/hoc/loadable/Panel';

const {
  constants: {
    API: { PRICING_UPDATE_URL },
  },
} = config;

const PlanSection = (props) => {
  const [errorFetched, setErrorFetched] = useState(-3);
  const userID = useSelector(selectUserId);
  const dispatch = useDispatch();
  const planDetails = useSelector(selectPlanDetails)?.toJS();
  const isLegacyAccount = useSelector(isLegacyAccountPlan)

  const getPlanDetails = () => {
    fetch(`${PRICING_UPDATE_URL}/ps/plan/${userID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': window.appAuthToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data?.userId) {
          dispatch(loadPlanSuccess(data))
          setErrorFetched(0);
        } else {
          setErrorFetched(prevCount => prevCount + 1);
          dispatch(LeaveMessagePopup.open({
            title: "Error",
            message: response.error,
            yesLable: "Ok",
            cancelLable: null,
            CancelRedirect: () => null,
            yesRedirect: () => null
          }))
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setErrorFetched(prevCount => prevCount + 1);
      });
  }
  const goToMonthlyPlan = () => {
    dispatch(updateSelectedPlanAnnual(false));
    props.history.push(`/accountnew/plan`);
  }

  const goToAnnualPlan = () => {
    dispatch(updateSelectedPlanAnnual(true));
    props.history.push(`/accountnew/plan`);
  }
  const getPlanName = () => {
    if (isLegacyAccount) return "Legacy";
    if (planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0) {
      const selectedPlan = planDetails.availableUserPlans.find(plan => plan.id === planDetails?.accountEnrolledPlans[0]?.planId);
      if (selectedPlan && selectedPlan?.name) return selectedPlan.name.split(' ')[0];
      return "";
    }
    return "";
  }
  
  const getIcon = () => {
    const planName = getPlanName();
    dispatch(loadAccountType(getNameIcon(planName)))
    if (planName.includes("Essentials")) return EssentialsIcon;
    else if (planName.includes("Pro")) return ProIcon;
    else if (planName.includes("Elite")) return EliteIcon;
    else if (isLegacyAccount) return LegacyIcon;
    else return EssentialsIcon;
  };

  const getNameIcon = (planName) => {
    if (planName.includes("Essentials")) return 'Essentials';
    else if (planName.includes("Pro")) return 'Pro';
    else if (planName.includes("Elite")) return 'Elite';
    else if (isLegacyAccount) return 'Legacy';
    else return '';
  };

  return (
    <div className={classNames(css.clsCard, css.clsPlanCard)}>
      <LoadablePanel loading={!planDetails?.accountEnrolledPlans.length}>
      <div className={classNames(css.clsCardHeader, css.d_flex, css.align_items_center, css.justify_content_between)}>
        <h4 className={classNames(css.clsCardTitle)}>Plan</h4>
        <div className={css.clsCardTxtGrp}>
          {planDetails?.accountEnrolledPlans.length > 0 && !planDetails?.accountEnrolledPlans[0]?.currentAnnual && !planDetails?.trialAvailable && <a href="javascript:;" onClick={goToAnnualPlan} className={classNames(css.clsCardTxt, css.text_warning)}>Upgrade to an Annual Plan to Save 17%</a>}
          {!planDetails?.trialAvailable && <a href="javascript:;" onClick={goToMonthlyPlan} className={classNames(css.clsCardTxt, css.text_primary)}>Manage Plan</a>}
        </div>
      </div>

      <div className={css.clsCardBody}>
        {errorFetched > 0 ? (<ErrorDisplay errorFetched={errorFetched} onReload={getPlanDetails} />) :
          planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0 && (
            <div className={classNames(css.d_flex, css.justify_content_center)}>
              <div className={isLegacyAccount? css.clsLegacyTxt : css.clsProTxt}>
                <h4> 
                  <ReactSVG src={getIcon()} className={css.planIcon} /><span>{getPlanName()}</span></h4>
              </div>
              <div className={css.clsTypeTxt}>
                <h4>TYPE</h4>
                <h5>{planDetails?.accountEnrolledPlans[0]?.currentAnnual ? "Annual" : "Monthly"}</h5>
              </div>
              <div className={classNames(css.clsTypeTxt, css.clsSaveTxt)}>
                <h4>SAVES & EXPORTS</h4>
                <h5>{numberFormat(planDetails?.accountEnrolledPlans[0]?.quantity)}/mo</h5>
              </div>
            </div>
          )}
      </div>
      </LoadablePanel>
    </div>
  );
};

export default withRouter(PlanSection);
